var map = {
	"./ADDVA_ENTRAN.svg": 74,
	"./ADDVA_EXCLUS.svg": 75,
	"./ADDVA_GUIDE.svg": 76,
	"./ADDVA_KIDS.svg": 77,
	"./ADDVA_LOCAL.svg": 78,
	"./ADDVA_MEAL.svg": 79,
	"./ADDVA_PRITOU.svg": 80,
	"./ADDVA_SMALL.svg": 81,
	"./ADDVA_SUBJEC.svg": 82,
	"./ADDVA_TOURAU.svg": 83,
	"./ADDVA_VOUCH.svg": 84,
	"./default_icon.svg": 85,
	"./fast.svg": 86,
	"./free.svg": 87,
	"./istant.svg": 88,
	"./official.svg": 89,
	"./skip.svg": 90
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 291;